import useMessageList from "./hooks/useMessageList";
import MessageCard from "./MessageCard";
import ScoreCard from "./ScoreCard";
import Loader from "../../components/Loader";
import styles from "./messageList.module.css";

const MessageList = ({ messages, score, levelUp, waiting }) => {
  const { messageEndRef } = useMessageList({ messages, score, waiting });
  return (
    <div className={styles.messageList}>
      {Array.isArray(messages)
        ? messages.map((message) => (
            <MessageCard key={JSON.stringify(message?.id)} {...message} />
          ))
        : null}
      {waiting && (
        <div>
          <Loader small />
        </div>
      )}
      {score != null ? <ScoreCard score={score} /> : null}
      <div ref={messageEndRef} />
    </div>
  );
};

export default MessageList;
